import React from "react";

export function SpeedIcon({ className }): JSX.Element {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0Z" />
      <path d="m20.39 8.56-1.24 1.86a8.02 8.02 0 0 1-.22 7.58H5.07A7.998 7.998 0 0 1 8 7.07a7.972 7.972 0 0 1 7.57-.23l1.86-1.24A10 10 0 0 0 3.59 8.55a9.979 9.979 0 0 0 .39 11.43h16c2.51-3.36 2.66-7.93.38-11.44Z" />
      <path d="M10.59 15.41c.78.78 2.04.78 2.82 0v-.01l5.66-8.49-8.49 5.66c-.79.78-.79 2.04-.01 2.82Z" />
    </svg>
  );
}
